import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
// The shared base first: it declares the layer order (reset, kt, kui). Then the
// app's element styles, the family themes, Kindly's accent and extras, the scale
// tokens and the shared UI.
import "@jkast90/kast-common/base.css";
import "./index.css";
import "@jkast90/kast-common/theme.css";
import "./theme.css";
import "@jkast90/kast-common/tokens.css";
import "@jkast90/kast-common/ui.css";
// Creating the theme store applies the saved theme and starts following the OS.
import "./theme";
import { completeSignIn } from "./auth/signIn";
import { installFetchRecorder } from "@jkast90/kast-common/diagnostics";

// Every request lands in the bug report's API log. Before the first render,
// so the first fetches are caught; the API client does not log calls itself.
installFetchRecorder();

// Back from login.kast-dev.net: the tokens in the URL start the session before
// the first render.
completeSignIn();

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error('index.html has no element with id "root"');

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
